export const WIDGET_HEADING_STYLE = 'font-metricRSemibold text-sm text-bw08';
export const WIDGET_TEXT_STYLE = 'font-metricR text-[12px] text-bw08';

export const WIDGET_CARD_STYLE = 'border-bw03 border-[1px] bg-bw00 rounded-[8px] w-[230px] flex flex-col items-center';
